/*eslint no-undef: 0*/

// == Function that disables background page scrolling on touch devices
const scrollDisableOnTouch = new function () {
  const $nodeHtml = document.documentElement,
    $pageWrapper = document.querySelector('.page-container');
  let scrollTop;

  this.init = () => {

    scrollTop = window.pageYOffset;
    $pageWrapper.style.top = '-' + scrollTop + 'px' + '';

    $nodeHtml.classList.add('disable-page-scrolling');
  };

  this.destroy = () => {
    $nodeHtml.classList.remove('disable-page-scrolling');
    $pageWrapper.removeAttribute('style');

    window.scrollTo(0, scrollTop);
    window.setTimeout(function () {
      scrollTop = null;
    }, 0);
  };
};

export default scrollDisableOnTouch;



// WEBPACK FOOTER //
// ./scripts/util/touchDeviceScrollPrevent.js